import styles from "./Card.module.css";

export function Card({ title, actions, children, className = "", ...props }) {
  return (
    <section className={[styles.card, className].filter(Boolean).join(" ")} {...props}>
      {(title || actions) && (
        <header className={styles.header}>
          {title && <h3 className={styles.title}>{title}</h3>}
          {actions && <div className={styles.actions}>{actions}</div>}
        </header>
      )}
      <div className={styles.body}>{children}</div>
    </section>
  );
}
